module.exports = __webpack_public_path__ + "media/Images/TPA-home-circle-149bf55cec5bb04762453cc4fecd9df9.jpg";